var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileBackArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8758 6.73756L18.907 6.74439H5.52391L9.73106 2.52797C9.93708 2.32211 10.0501 2.04325 10.0501 1.75057C10.0501 1.45789 9.93708 1.18098 9.73106 0.974634L9.07642 0.319675C8.87057 0.113821 8.59626 0 8.30374 0C8.01106 0 7.73659 0.113008 7.53073 0.318862L0.318866 7.53008C0.112199 7.73675 -0.000808652 8.01203 4.35632e-06 8.30488C-0.000808652 8.59935 0.112199 8.87479 0.318866 9.08114L7.53073 16.293C7.73659 16.4987 8.0109 16.6119 8.30374 16.6119C8.59626 16.6119 8.87057 16.4985 9.07642 16.293L9.73106 15.638C9.93708 15.4325 10.0501 15.158 10.0501 14.8654C10.0501 14.5728 9.93708 14.3128 9.73106 14.1072L5.47643 9.86715H18.8907C19.4935 9.86715 20 9.34764 20 8.7452V7.81886C20 7.21642 19.4785 6.73756 18.8758 6.73756Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBackArrowIcon);
export default __webpack_public_path__ + "static/media/profile_back-arrow_icon.5e1a9e71cec459717830d5a678ceaca4.svg";
export { ForwardRef as ReactComponent };